// 定义setter里面的一些函数“接口” 更工程化

// 设置Locale的方法
export const SET_LOCALE = 'SET_LOCALE'

export const SET_CONNECT = 'SET_CONNECT'



// WEBPACK FOOTER //
// ./examples/store/mutation-types.js